export default "__VITE_ASSET__vyRyZ1yo__"